<script lang="ts" setup>
    interface IFeature {
        title: string
        description: string
        image: string
    }
    interface ICardWhyUsProps {
        data: IFeature
    }
    const props = defineProps<ICardWhyUsProps>()

    // Strip HTML (e.g. <br>) from title for a clean, always-present alt attribute
    const imageAlt = computed(() =>
        (props.data.title || '')
            .replace(/<[^>]*>/g, ' ')
            .replace(/\s+/g, ' ')
            .trim()
    )
</script>

<template>
    <div class="card-why-us">
        <div class="card-why-us__image-container">
            <img 
                :src="props.data.image" 
                :alt="imageAlt || 'Why choose Samurai Rekrutmen'"
                class="card-why-us__image ratio-item"
            >
        </div>
        <div class="card-why-us__content">
            <h3 class="card-why-us__title" v-html="props.data.title"></h3>
            <p class="card-why-us__description">
                {{ props.data.description }}
            </p>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.card-why-us {
    @include imageRatio(170 170, 150 150, true,contain);
    @include vwUnit('padding', 24, 22);
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    height: 100%;
    transition: all 0.4s ease;


    &:hover {
        transform: translateY(-8px);
    }

    &__image-container {
        @include vwUnit('margin-bottom', 24, 20);
    }

    &__title {
        font-family: $primary-font;
        color: #211F1F;
        font-weight: 600;
        line-height: 1.2;
        @include vwUnit('font-size', 26, 26);
        @include vwUnit('margin-bottom', 24, 20);
    }

    &__description {
        margin-bottom: 0px;
        color: #404040;
        font-weight: 400;
        line-height: 1.6;
        @include vwUnit('font-size', 18, 18);
        font-family:$primary-font-light;
        @media only screen and (max-width: 1399.98px) {
            font-size: 16px;
        }
    }
}
</style>
